export default __webpack_public_path__ + "static/media/CEM-VR.bcd11b6d.jpg";